import ContentSubject from './ContentSubject';

export enum ArtContentStrand {
  ArtisticFoundations = 'Artistic Foundations',
  ArtisticProcessCreateOrMake = 'Artistic Process: Create or Make',
  ArtisticProcessPerformOrPresent = 'Artistic Process: Perform or Present',
  ArtisticProcessRespondOrCritique = 'Artistic Process: Respond or Critique',
}

export enum EnglishContentStrand {
  Reading = 'Reading',
  Writing = 'Writing',
  SpeakingViewingAndMediaLiteracy = 'Speaking, Viewing, and Media Literacy',
}

export enum MathContentStrand {
  Algebra = 'Algebra',
  GeometryAndMeasurement = 'Geometry & Measurement',
  DataAnalysisAndProbability = 'Data Analysis & Probability',
  NumberAndOperation = 'Number & Operation',
}

export enum ScienceContentStrand {
  NatureOfScienceAndEngineering = 'Nature of Science and Engineering',
  PhysicalScience = 'Physical Science',
  LifeScience = 'Life Science',
  EarthScience = 'Earth Science',
}

export enum SocialStudiesContentStrand {
  CitizenshipAndGovernment = 'Citizenship and Government',
  Economics = 'Economics',
  History = 'History',
  Geography = 'Geography',
}

export const ContentStrandMapping = {
  [ContentSubject.Art]: ArtContentStrand,
  [ContentSubject.English]: EnglishContentStrand,
  [ContentSubject.Math]: MathContentStrand,
  [ContentSubject.Science]: ScienceContentStrand,
  [ContentSubject.SocialStudies]: SocialStudiesContentStrand,
};

type ContentStrand =
  | ArtContentStrand
  | EnglishContentStrand
  | MathContentStrand
  | ScienceContentStrand
  | SocialStudiesContentStrand;

export default ContentStrand;
